import { useQuery } from '@tanstack/react-query';
import { AlertTriangle, CheckCircle2, Clock, Inbox, Loader2 } from 'lucide-react';
import { StatCard } from '@/components/ui/stat-card';
import { techSupportService } from '@/services/tech-support.service';

export function TechSupportDashboardCards() {
  const { data, isLoading } = useQuery({
    queryKey: ['tech-support', 'dashboard'],
    queryFn: () => techSupportService.getDashboard(),
  });

  const stats = data?.data?.data;

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="h-24 rounded-xl bg-muted animate-pulse" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
      <StatCard label="Open" value={stats?.open ?? 0} icon={Inbox} tone="sky" />
      <StatCard label="In Progress" value={stats?.in_progress ?? 0} icon={Loader2} tone="amber" />
      <StatCard label="Resolved Today" value={stats?.resolved_today ?? 0} icon={CheckCircle2} tone="emerald" />
      <StatCard label="Overdue" value={stats?.overdue ?? 0} icon={AlertTriangle} tone="rose" />
      <StatCard label="Avg Resolution" value={`${stats?.avg_resolution_hours ?? 0}h`} icon={Clock} tone="violet" />
    </div>
  );
}
